module.exports = __webpack_public_path__ + "img/sarlbernardtraineau.aac28199.png";